const arcades = [
  {
    name: "DanceRush Stardom",
    count: 2,
    category: "Rhythm",
    players: "2 Players",
    image: "dancerush.jpg",
  },

  {
    name: "WACCA Reverse",
    count: 3,
    category: "Rhythm",
    players: "1 Player",
    image: "wacca.jpg",
  },

  {
    name: "Project DIVA",
    count: 1,
    category: "Rhythm",
    players: "1 Player",
    image: "diva.jpg",
  },

  {
    name: "Love Live! After School Idol",
    count: 1,
    category: "Rhythm",
    players: "1 Player",
    image: "lovelive.jpg",
  },
  {
    name: "In The Groove",
    count: 2,
    category: "Rhythm",
    players: "2 Players",
    image: "itg.jpg",
  },

  {
    name: "Vewlix L",
    count: 2,
    category: "Fighting",
    players: "2 Players",
    image: "vewlix.jpg",
    note: "Official Taito Vewlix cabinets currently configured with PlayStation 4 hardware. Can be configured with different PS4 titles upon request."
 },

  {
    name: "Noir Cabinet",
    count: 2,
    category: "Fighting",
    players: "2 Players",
    image: "noir.jpg",
    note: "Currently configured for Tekken 8.",
  },

  {
    name: "Pop'n Music HD",
    count: 1,
    category: "Rhythm",
    players: "1 Player",
    image: "pop.jpg",
  },

  {
    name: "Final Fantasy Theatrhythm",
    count: 1,
    category: "Rhythm",
    players: "2 Players",
    image: "ff.jpg",
  },

  {
    name: "Dance Dance Revolution Extreme",
    count: 1,
    category: "Rhythm",
    players: "2 Players",
    image: "ddr.jpg",
  },

 {
    name: "Sega UFO Catcher",
    count: 3,
    category: "Prize",
    players: "1 Player",
    image: "ufo.jpg",
  },

  {
    name: "Barber Cut Lite",
    count: 1,
    category: "Prize",
    players: "1 Player",
    image: "barbercut.jpg",
  },

  {
    name: "Sega Prize Locker",
    count: 1,
    category: "Prize",
    players: "1 Player",
    image: "prizelocker.jpg",
  },

  {
    name: "Puzzle & Dragons",
    count: 2,
    category: "Puzzle",
    players: "1 Player",
    image: "pnd.jpg",
  },

  {
    name: "Steel Chronicle",
    count: 1,
    category: "Action",
    players: "1 Player",
    image: "steel-chronicle.jpg",
  },

  {
    name: "Sound Voltex Exceed Gear",
    count: 1,
    category: "Rhythm",
    players: "1 Player",
    image: "sdvx.jpg",
  },

  {
    name: "Dance Evolution",
    count: 1,
    category: "Rhythm",
    players: "2 Players",
    image: "danceevo.jpg",
  },

  {
    name: "Tomy Gacha Machines",
    count: 62,
    category: "Prize",
    players: "1 Players",
    image: "gacha.jpg",
}
];

export default arcades;